import { settings } from "../config/config";



//appends stylesheet to specific element taking in class or id name
const appendStyleSheet = (styles, selector) => {
  let css = document.createElement('style');
  css.type = 'text/css';
  css.appendChild(document.createTextNode(styles));
  window.parent.document.querySelector(selector).appendChild(css);
};



//this method takes in an string and checks the dom for elements that have either a class or id with this name
//and returns an array with data showing if element is on dom and if element is a class or not
const checkDomForElement = (selector) => !window.parent.document.querySelector(selector) ? false : true;


//this method uses settings and checkdom and appendstyles methods to check for element and append styles to appropriate element based on settings
const checkDomAndAppenedStyles = () => {
  //if custom styles exists and is enabled in embedSettings it will be appended to the dom.
  if (settings["embed"]["styles"]["custom"] && settings["embed"]["styles"]["custom"]["enabled"]) {
    const className = `.embedid-${settings["embed"]["uuid"]}`;
    const styles = settings["embed"]["styles"]["custom"]["styles"];
    const onDom = checkDomForElement(className);
    onDom ? appendStyleSheet(styles, className) : appendStyleSheet(styles, '#insticator-container') // if embedId class isnt found on the dom we will append the custom styles to the '#insticator-container' element, in this case client only has one embed on page
  }
};



export { appendStyleSheet, checkDomForElement, checkDomAndAppenedStyles };